/**
 * The client filter rule, shared by every screen that offers it (Carteira, Fila,
 * Curadoria and Mapa). It lives in one place because the four have to answer the same
 * question the same way: picking a client brings ALL of its brands, since it is the
 * client the OP carries that decides, never its brand.
 *
 * Mirrors apps/server/src/modules/ops/motor/cliente-filtro.util.ts.
 */

/** The comparison key: the VESTO writes the same client in two different cases. */
export const clienteKey = (cliente: string): string => cliente.trim().toUpperCase();

/** `true` when the OP belongs to ONE of the chosen clients; an empty list filters nothing. */
export function incluiCliente(escolhidos: Array<string>, cliente: string): boolean {
  if (escolhidos.length === 0) {
    return true;
  }
  const chave = clienteKey(cliente);
  return chave !== '' && escolhidos.some((escolhido) => clienteKey(escolhido) === chave);
}

/**
 * The clients present in a list, alphabetical and WITHOUT repeating by case: two
 * identical lines in the builder would look like two clients. The first spelling read
 * stays, which is the one shown on the table.
 */
export function clientesUnicos(nomes: Array<string>): Array<string> {
  const porChave = new Map<string, string>();
  for (const nome of nomes) {
    const cliente = nome.trim();
    if (cliente !== '' && !porChave.has(clienteKey(cliente))) {
      porChave.set(clienteKey(cliente), cliente);
    }
  }
  return [...porChave.values()].sort((a, b) => a.localeCompare(b, 'pt-BR'));
}
